import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Switch, Text } from '@mantine/core';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
export default function EntityConfigSettings({
  effortId = null,
  usePublicDashboard = false,
  onUpdate = () => {},
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    use_public_dashboard: false,
  });

  useEffect(() => {
    setFormValues({
      ...formValues,
      use_public_dashboard: usePublicDashboard,
    });
  }, []);

  function onSubmit() {
    setLoading(true);

    const req = {
      ...formValues,
      campaign_effort_id: effortId,
    };

    axios
      .post(`/update-settings/`, req)
      .then(() => {
        setLoading(false);
        toast.success(t('common:saved') + '!');
        onUpdate();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <div>
      <Text fw={600} mb="xs">
        {t('mixer:effort:public_dashboard_title')}
      </Text>
      <Switch
        label={t('mixer:effort:public_dashboard_label')}
        size="sm"
        onChange={(e) =>
          setFormValues({
            ...formValues,
            use_public_dashboard: !formValues.use_public_dashboard,
          })
        }
        checked={formValues.use_public_dashboard === true}
      />
      <Button loading={loading} mt="md" size="sm" onClick={onSubmit}>
        {t('common:save')}
      </Button>
    </div>
  );
}
